module.exports = __webpack_public_path__ + "img/xh-pic1.25a25570.png";